export default __webpack_public_path__ + "static/media/undraw_eating_together.96e83fe8.svg";